export const ICONS = {
  SETTINGS: {
    name: 'Settings',
    icon: 'icon-settings',
    iconSelected: 'icon-settings-selected',
  },
  ADMIN: {
    name: 'Admin',
    icon: 'icon-admin',
  },
  LOGOUT: {
    name: 'Log Out',
    icon: 'icon-logout',
  },
};

export const MICROPHONE_ICONS = {
  muted: 'icon-microphone-muted',
  unmuted: 'icon-microphone',
};
